import { createRoot } from 'react-dom/client'
import { MantineProvider } from '@mantine/core'
import '../styles/application.css'
import '@mantine/core/styles.css'
import '@mantine/dates/styles.css'
import 'flatpickr/dist/flatpickr.min.css'
import '../styles/flatpickr-theme.css'
import { theme } from '../theme'
import { registry } from '../components/registry'
import { initDiffSubmit } from '../lib/diffSubmit'
import { initDatePickers } from '../lib/datePicker'
import { initStickyCta } from '../lib/stickyCta'
import { initSearchDialogs } from '../lib/searchDialog'
import { initRoleFields } from '../lib/roleFields'

// Rails Viewに <div data-react-component="ComponentName" data-react-props='{"foo":"bar"}'></div>
// を置くと、対応するReactコンポーネントがマウントされる（React islandsパターン）。
// 既存ERBビューを壊さず、画面単位で段階的にReact/Mantineを導入するための仕組み。
function mountReactComponents() {
  document.querySelectorAll('[data-react-component]').forEach((el) => {
    // data-turbolinks-permanent な要素(AppNavbarなど)はTurbolinksのページ遷移で
    // DOM自体が使い回されるため、Reactツリーもそのまま維持して再マウントしない。
    if (el.dataset.reactMounted) return

    const name = el.dataset.reactComponent
    const Component = registry[name]
    if (!Component) {
      console.error(`Unknown React component: ${name}`)
      return
    }
    const props = el.dataset.reactProps ? JSON.parse(el.dataset.reactProps) : {}
    createRoot(el).render(
      <MantineProvider theme={theme}>
        <Component {...props} />
      </MantineProvider>
    )
    el.dataset.reactMounted = 'true'
  })
}

// Ajaxで差し替えた領域(users/match.js.erb など)から再マウントを呼べるように公開する。
// 既にマウント済みの要素は data-react-mounted で skip されるので、何度呼んでも安全。
window.mountReactComponents = mountReactComponents

function boot() {
  mountReactComponents()
  initDiffSubmit()
  initDatePickers()
  initStickyCta()
  initSearchDialogs()
  initRoleFields()
}

// type="module"スクリプトはdefer相当で読み込まれるため、
// 初回ロード時はDOMContentLoadedを取りこぼす可能性がある。readyState確認で即時マウントも行う。
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot)
} else {
  boot()
}
document.addEventListener('turbolinks:load', boot)
